import { Directive, HostListener, EventEmitter, Output, Input } from '@angular/core';
import { SIDE_MENU_DIMENSIONS } from '../../enclosure/models/enclosure.constants';

@Directive({
    selector: '[appSelectionResizer]',
    standalone: false
})
export class SelectionResizerDirective {
  private resizeInProgress = false;

  @Input() resizableElement: HTMLDivElement;
  @Input() maxRelativeWidth: number;
  @Input() minRelativeWidth: number;
  @Input() configurationBarHidden: boolean;

  @Output() resized = new EventEmitter<number>();

  @HostListener('mousedown', ['$event'])
  @HostListener('pointerdown', ['$event'])
  OnDown(event: MouseEvent | PointerEvent) {
    if (!this.isLeftClick(event)) {
      return;
    }
    this.startResizing();
  }

  @HostListener('document:mousemove', ['$event'])
  @HostListener('document:pointermove', ['$event'])
  OnMove(event: MouseEvent | PointerEvent) {
    if (!this.resizeInProgress) {
      return;
    }
    this.resize(event);
  }

  @HostListener('document:mouseup', ['$event'])
  @HostListener('document:pointerup', ['$event'])
  OnUp(_event: MouseEvent | PointerEvent) {
    if (!this.resizeInProgress) {
      return;
    }
    this.endResizing();
  }

  private startResizing() {
    if (this.configurationBarHidden) {
      return;
    }
    this.resizeInProgress = true;
  }

  private resize(event: MouseEvent | PointerEvent) {
    const width = this.getResizableWidthOfElement(this.resizableElement, event);
    if (width > this.maxRelativeWidth || width > SIDE_MENU_DIMENSIONS.maxSizeInPx
      || width < this.minRelativeWidth || width < SIDE_MENU_DIMENSIONS.minSizeInPx) {
      return;
    }
    this.resizableElement.style.width = width + 'px';
  }

  private endResizing() {
    this.resizeInProgress = false;
    this.resized.emit(this.resizableElement.getBoundingClientRect().width);
  }

  private isLeftClick(event: MouseEvent | PointerEvent): boolean {
    return event.button === 0;
  }

  private getResizableWidthOfElement(resizableElement: HTMLDivElement, event: MouseEvent | PointerEvent): number {
    const delta = resizableElement.getBoundingClientRect().x - event.x;

    return this.resizableElement.getBoundingClientRect().width + delta;
  }

}
